<script>
import SegmentTabEvaluations from '@/modules/audiences/pages/SegmentTabEvaluations'
import { evaluateRollingSegmentTaskIdentifierLabel as evaluateRollingSegmentIdentifierLabel } from '@/modules/tasks/enum/TaskRecordEnums'

export default {
  name: 'SegmentEvaluations',

  extends: SegmentTabEvaluations,

  mounted() {
    this.evaluateIdentifierLabel = evaluateRollingSegmentIdentifierLabel
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/RollingSegmentTabEvaluations.vue